import RequestsList from '../../components/Requests';

export default function Requests() {
  return <RequestsList />;
}
